const SEARCH_URL = '/recherche/';

const redirectToSearch = (query) => {
  const trimmed = query.trim();
  if (!trimmed) return;
  window.location.href = `${SEARCH_URL}?q=${encodeURIComponent(trimmed)}`;
};

const NavSearch = () => {
  const searchInputs = document.querySelectorAll('.search-input');
  const searchIconButtons = document.querySelectorAll('.search-icon-button');

  searchInputs.forEach((input) => {
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        redirectToSearch(input.value);
      }
    });
  });

  searchIconButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.search-wrapper');
      const input = wrapper?.querySelector('.search-input');
      if (input && input.value.trim()) {
        redirectToSearch(input.value);
      }
    });
  });
};

export default NavSearch;
